/**
 * Attributs et compétences de VtM V5.
 * Les identifiants (anglais) sont stockés en base ; les libellés sont affichés selon la langue.
 */

export const TRAIT_CATEGORIES = ['physical', 'social', 'mental'];

export const CATEGORY_LABELS = {
  physical: {fr: 'Physique', en: 'Physical'},
  social: {fr: 'Social', en: 'Social'},
  mental: {fr: 'Mental', en: 'Mental'},
};

export const ATTRIBUTES = [
  {id: 'strength', category: 'physical', name: {fr: 'Force', en: 'Strength'}},
  {id: 'dexterity', category: 'physical', name: {fr: 'Dextérité', en: 'Dexterity'}},
  {id: 'stamina', category: 'physical', name: {fr: 'Vigueur', en: 'Stamina'}},
  {id: 'charisma', category: 'social', name: {fr: 'Charisme', en: 'Charisma'}},
  {id: 'manipulation', category: 'social', name: {fr: 'Manipulation', en: 'Manipulation'}},
  {id: 'composure', category: 'social', name: {fr: 'Sang-froid', en: 'Composure'}},
  {id: 'intelligence', category: 'mental', name: {fr: 'Intelligence', en: 'Intelligence'}},
  {id: 'wits', category: 'mental', name: {fr: 'Astuce', en: 'Wits'}},
  {id: 'resolve', category: 'mental', name: {fr: 'Résolution', en: 'Resolve'}},
];

/** `requiresSpecialty` : une spécialité est obligatoire dès le premier point (Érudition, Artisanat, Représentation, Science). */
export const SKILLS = [
  {id: 'athletics', category: 'physical', name: {fr: 'Athlétisme', en: 'Athletics'}},
  {id: 'brawl', category: 'physical', name: {fr: 'Bagarre', en: 'Brawl'}},
  {id: 'craft', category: 'physical', name: {fr: 'Artisanat', en: 'Craft'}, requiresSpecialty: true},
  {id: 'drive', category: 'physical', name: {fr: 'Conduite', en: 'Drive'}},
  {id: 'firearms', category: 'physical', name: {fr: 'Armes à feu', en: 'Firearms'}},
  {id: 'larceny', category: 'physical', name: {fr: 'Larcin', en: 'Larceny'}},
  {id: 'melee', category: 'physical', name: {fr: 'Mêlée', en: 'Melee'}},
  {id: 'stealth', category: 'physical', name: {fr: 'Furtivité', en: 'Stealth'}},
  {id: 'survival', category: 'physical', name: {fr: 'Survie', en: 'Survival'}},
  {id: 'animalKen', category: 'social', name: {fr: 'Animaux', en: 'Animal Ken'}},
  {id: 'etiquette', category: 'social', name: {fr: 'Étiquette', en: 'Etiquette'}},
  {id: 'insight', category: 'social', name: {fr: 'Perspicacité', en: 'Insight'}},
  {id: 'intimidation', category: 'social', name: {fr: 'Intimidation', en: 'Intimidation'}},
  {id: 'leadership', category: 'social', name: {fr: 'Commandement', en: 'Leadership'}},
  {id: 'performance', category: 'social', name: {fr: 'Représentation', en: 'Performance'}, requiresSpecialty: true},
  {id: 'persuasion', category: 'social', name: {fr: 'Persuasion', en: 'Persuasion'}},
  {id: 'streetwise', category: 'social', name: {fr: 'Expérience de la rue', en: 'Streetwise'}},
  {id: 'subterfuge', category: 'social', name: {fr: 'Subterfuge', en: 'Subterfuge'}},
  {id: 'academics', category: 'mental', name: {fr: 'Érudition', en: 'Academics'}, requiresSpecialty: true},
  {id: 'awareness', category: 'mental', name: {fr: 'Vigilance', en: 'Awareness'}},
  {id: 'finance', category: 'mental', name: {fr: 'Finances', en: 'Finance'}},
  {id: 'investigation', category: 'mental', name: {fr: 'Investigation', en: 'Investigation'}},
  {id: 'medicine', category: 'mental', name: {fr: 'Médecine', en: 'Medicine'}},
  {id: 'occult', category: 'mental', name: {fr: 'Occultisme', en: 'Occult'}},
  {id: 'politics', category: 'mental', name: {fr: 'Politique', en: 'Politics'}},
  {id: 'science', category: 'mental', name: {fr: 'Science', en: 'Science'}, requiresSpecialty: true},
  {id: 'technology', category: 'mental', name: {fr: 'Technologie', en: 'Technology'}},
];

export const ATTRIBUTE_IDS = ATTRIBUTES.map(attribute => attribute.id);
export const SKILL_IDS = SKILLS.map(skill => skill.id);

const byId = (list) => list.reduce((acc, item) => ({...acc, [item.id]: item}), {});
export const ATTRIBUTES_BY_ID = byId(ATTRIBUTES);
export const SKILLS_BY_ID = byId(SKILLS);

/** Libellé localisé d'une donnée de référence ({fr, en}), avec repli sur le français. */
export const localized = (value, lng = 'fr') => (value && (value[lng] || value.fr)) || '';
